export default "__VITE_ASSET__DkAxq7yl__"